var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWavsedlp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F5AF6",
    d: "m12 0 12 12-12 12L0 12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7CBFF",
    d: "m16 20-4 4-4.7-4.7v-1l-.9-1.1v-3.5h5v2.6L16 13h-4V11h5.7v6.2l-1.7 1.2v1.6ZM11.3 6.3h-2V12l2-1.4V6.3ZM14.1 6.3h-2v3.9h2V6.3ZM17 6.3h-2.2v3.9H17V6.3ZM8.5 6.3h-2v6.6h1.4l.6-.4V6.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavsedlp);
export default __webpack_public_path__ + "static/media/WAVSEDLP.4f7ff8bee3a3713bfcef6f3be805632f.svg";
export { ForwardRef as ReactComponent };